export const dashboardTour = [
  {
    route: "/dashboard",
    target: ".org-select",
    content: "Select your organization from the dropdown.",
    placement: "left",
    disableBeacon: true,
  },
  {
    route: "/dashboard",
    target: ".dropdown-toggle",
    content: "Access your profile, change password, and logout from here.",
    placement: "left",
    // disableBeacon: true,
  },
  {
    route: "/dashboard",
    target: ".visit-summary-tour",
    content:
      "This section shows your visit summary including patient visits, generated reports, and delayed reports. Use the quick filters to view data for Today, Last 2 Days, or Last 7 Days.",
    placement: "right",
  },
 {
    route: "/dashboard",
    target: ".ratecard-search",
    content: "Search tests by name or code to fetch the RNI rate for test.",
    placement: "left",
  },
  {
    route: "/dashboard",
    target: ".balance-card",
    content: "View your account balance, deposits and transactions here.",
    placement: "left",
  },
  {
    route: "/dashboard",
    target: ".updates-card",
    content: "Important updates and notifications will appear here.",
    placement: "top",
  },
  {
    route: "/dashboard",
    target: ".service-console",
    content: "Quick access to DOS and partner case services.",
    placement: "left",
  },
  {
    route: "/dashboard",
    target: ".test-revenue-card",
    content: "View the top tests and their revenue for the selected month. You can change the month from the dropdown and sort the list by revenue or test count to analyze performance.",
    placement: "left",
  },
];
